import PrefixEnum from '../prefixes'

export default Object.freeze({
    'levelup.gymondo.fitness': PrefixEnum.HARRISON2,
})
